import React from 'react'

import { Center, PaddingInset, spacing, Stack, Text } from '@cash-design-system/react'
import { FormBlockerElementHeroElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'

export function HeroElement(props: FormBlockerElementHeroElement): React.ReactElement {
  // TODO: Implement props.animation and props.animation_width_percentage (FSWEB-10112)
  const textTokenizer = useTextTokenizer()

  return (
    <PaddingInset>
      <Stack space={spacing.m}>
        {props.title && (
          <Center centerText={true}>
            <Text typography="hero" as="h1">
              {textTokenizer(props.title)}
            </Text>
          </Center>
        )}
        {props.subtitle && (
          <Center centerText={true}>
            <Text typography="body">{textTokenizer(props.subtitle)}</Text>
          </Center>
        )}
      </Stack>
    </PaddingInset>
  )
}
